@if (!isDynamicdashboard) {
  <h2><mibp-resource-string key="Dashboard_CreditLimit"></mibp-resource-string></h2>
}
@if (!isDelSeq) {
  <div>
    <span class="dashboard-number-description"><mibp-resource-string key="CreditLimit_ActAsCustomerForFeature"></mibp-resource-string></span>
  </div>
}
@if (isDelSeq) {
  <mibp-chart-pie  [doughnut]="true" [loading]="isLoading"  [data]="creditLimitChartData" width="250px" height="null" [colors]='color' [aspectRatio]="1" [cutoutPercentage]="85"></mibp-chart-pie>
}

@if (isDelSeq) {
  <div class="statuses">
    @if (CreditUsedCount <= 0 && CreditRemainingCount <= 0) {
      <div><span class="credit-no_data"><mibp-resource-string key="CreditLimit_NoData"></mibp-resource-string></span></div>
    }
    <ul class="credit-status-list">
      @if (CreditUsedCount > 0 && CreditUsedCount <= 50) {
        <li><span class="credit-status Used"  (click)="activeInfo.open($event.target)" ><mibp-resource-string key="Credit_Used"></mibp-resource-string>: {{ CreditUsedCount }} %</span></li>
      }
      @if (CreditUsedCount > 50 && CreditUsedCount <= 75) {
        <li><span class="credit-status Used1" (click)="activeInfo.open($event.target)"><mibp-resource-string key="Credit_Used"></mibp-resource-string>: {{ CreditUsedCount }} %</span></li>
      }
      @if (CreditUsedCount > 75 && CreditUsedCount <= 100) {
        <li ><span class="credit-status Used2" (click)="activeInfo.open($event.target)"><mibp-resource-string key="Credit_Used"></mibp-resource-string>: {{ CreditUsedCount }} %</span></li>
      }
      @if (CreditRemainingCount > 0) {
        <li><span class="credit-status remaining" (click)="inactiveInfo.open($event.target)"><mibp-resource-string key="Credit_Remaining"></mibp-resource-string>: {{ CreditRemainingCount }} %</span></li>
      }
    </ul>
  </div>
}


<mibp-new-popover #activeInfo>
  <p><strong><mibp-resource-string key="Credit_Used"></mibp-resource-string></strong>: {{CreditUsedCount}}<mibp-resource-string key="Credit_Used_Description"></mibp-resource-string></p>
</mibp-new-popover>

<mibp-new-popover #inactiveInfo>
  <p><strong><mibp-resource-string key="Credit_Remaining"></mibp-resource-string></strong>:  {{CreditRemainingCount}}<mibp-resource-string key="Credit_Remaining_Description"></mibp-resource-string></p>
</mibp-new-popover>

